<template>
    <div>
        <!-- <van-nav-bar title="搜索新闻动态" left-arrow @click-left="onClickLeft" /> -->
        <van-search v-model="searchQuery" placeholder="请输入搜索关键词" @search="onSearch" />
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell-group>
                <van-cell v-for="item in searchResults" :key="item.id" :title="item.title" class="news-item" is-link
                    :label="item.releaseTime !== null ? item.releaseTime.slice(0, 10) : '-'" @click="showDetail(item)">
                    <!-- <template #extra>
                    <van-image v-if="appOrPC" class="news-img"
                        :src="searchType == '0' ? getIMGURL(item.imageId, 0) : getIMGURL(item.imageUrl, 1)">
                    </van-image>
                    <van-image v-else class="news-img" :src="searchType == '0' ? getImage(item.imageUrl) : item.imageUrl">
                    </van-image>
                </template> -->
                </van-cell>
            </van-cell-group>
        </van-list>
    </div>
</template>

<script>
import { get } from '@/utils/api'
import { appOrPC, ipType, IMAGE_URL, interface_pubkey1, interface_prikey1 } from '@/utils/config';
export default {
    name: 'SearchNews',
    data() {
        return {
            searchQuery: localStorage.getItem('newsSearchQuery'),
            areaCode: localStorage.getItem('areaCode'),
            searchType: localStorage.getItem('searchType'),
            searchResults: [],
            loading: false,
            finished: false,
            pageNo: 1,
            pageSize: 20,
            IMAGE_URL: IMAGE_URL,
            appOrPC: appOrPC
        }
    },
    methods: {
        onClickLeft() {
            this.$router.back()
        },
        onSearch() {
            this.searchResults = []
            this.pageNo = 1
            this.finished = false
            this.loading = true
            this.onLoad()
        },
        onLoad() {
            this.getNewsDatas()
        },
        async getNewsDatas() {
            if (appOrPC) {
                let that = this, extraData = {
                    header: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                        "App-Version-Code": "v2.0.0"
                    }
                }, newsArray;
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify({
                        ipType: ipType,
                        methodType: "get",
                        methodName: "api/app/news/page",
                        type: that.searchType,
                        pageNo: that.pageNo,
                        pageSize: 20,
                        searchValue: that.searchQuery,
                        areaCode: that.areaCode,
                    }),
                    "1",
                    extraData
                ).then((value) => {
                    if (value == false) {
                        return;
                    } else {
                        const de_value = JSON.parse(value)
                        if (de_value.code == 200 && de_value.success) {
                            newsArray = de_value.data.rows;
                            // for (let i = 0; i < newsArray.length; i++) {
                            //     that.searchResults.push({
                            //         id: newsArray[i].id,
                            //         title: newsArray[i].title,
                            //         label: newsArray[i].abstarct,
                            //         date: newsArray[i].releaseTime !== null ? newsArray[i].releaseTime.slice(0, 10) : "-",
                            //         imageUrl: newsArray[i].imageId !== undefined ? newsArray[i].imageId : newsArray[i].imageUrl,
                            //     })
                            // }
                            that.searchResults = newsArray
                        } else {
                            that.$toast.fail(de_value.message || '获取首页信息失败');
                        }
                        that.loading = false
                        that.pageNo++
                        if (newsArray.length < 20) {
                            that.finished = true
                        }
                    }
                })
            } else {
                const param = {
                    type: this.searchType,
                    pageNo: this.pageNo,
                    pageSize: 20,
                    searchValue: this.searchQuery,
                    areaCode: this.areaCode,
                };
                const res = await get('/news/page', param);
                let newsArray;
                if (res.code == 200 && res.success) {
                    newsArray = res.data.rows;
                    // for (let i = 0; i < newsArray.length; i++) {
                    //     this.searchResults.push({
                    //         id: newsArray[i].id,
                    //         title: newsArray[i].title,
                    //         label: newsArray[i].abstarct,
                    //         date: newsArray[i].releaseTime !== null ? newsArray[i].releaseTime.slice(0, 10) : "-",
                    //         imageUrl: newsArray[i].imageId !== undefined ? newsArray[i].imageId : newsArray[i].imageUrl,
                    //     })
                    // }
                    this.searchResults = newsArray
                } else {
                    this.$toast.fail(res.message || '获取首页信息失败');
                }
                this.loading = false
                this.pageNo++
                if (newsArray.length < 20) {
                    this.finished = true
                }
            }
        },

        getImage(id) {
            let token = localStorage.getItem("token")
            return IMAGE_URL + `?id=${id}&token=${token}`
        },
        showDetail(item) {
            localStorage.setItem('newsSearchQuery', this.searchQuery)
            let type = this.searchType;
            let areaCode = this.areaCode === "" ? 0 : this.areaCode;
            this.$router.push({ path: `/news-detail/${item.id}/${item.title}/${type}/${areaCode}` });
        },
        getIMGURL(id, type) {
            const token = localStorage.getItem("token");
            let url = "", that = this
            if (type) {
                if (id == "") {
                    return require('@/assets/icon/noimage.png');
                } else {
                    url = id
                }
            } else {
                url = that.IMAGE_URL + `?id=${id}&token=${token}`
            }
            try {
                const param = {
                    ipType: ipType,
                    methodType: "get",
                    methodName: "getImageBase64",
                    imgURL: url
                };
                vaildInterfacefn(
                    "hhwzzcsesonq",
                    "rcshhwtyjkV0",
                    JSON.stringify(param),
                    "1"
                ).then((value) => {
                    if (value == false) {
                        throw new Error('获取图片失败');
                        // return
                    } else {
                        const de_value = JSON.parse(value);
                        if (de_value.code === 200 && de_value.imageBase64) {
                            const base64Image = "data:image/jpeg;base64," + de_value.imageBase64;
                            // console.log("base64Image:", base64Image);
                            return base64Image;
                        } else {
                            throw new Error(de_value.msg || '获取图片失败');
                        }
                    }
                })
            } catch (error) {
                console.error('获取图片失败:', error);
                this.$toast.fail('获取图片失败');
                // 返回默认图片
                return require('@/assets/icon/noimage.png');
            }
        }
    },
    mounted() {
        if (this.searchQuery) {
            this.onSearch()
        }
    }
}
</script>

<style scoped>
.van-search {
    padding: 10px;
}

.van-nav-bar {
    background-color: #0081ff;
}

/* /deep/ is deprecated, use ::v-deep instead */
::v-deep(.van-nav-bar__title),
::v-deep(.van-nav-bar .van-icon),
::v-deep(.van-nav-bar__text) {
    color: #fffbf8;
}

.news-item {
    /* margin: 10px 12px; */
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
    padding: 12px;
    position: relative;
}

.news-img {
    width: 80px;
    height: 80px;
}

.van-cell__title {
    /* position: absolute; */
    width: 100%;
    /* left: 114px; */
}

.van-cell__title span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.van-cell__label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
